// This initializes <billboard> tags on page load & tubrbo frame loads
// which have been generated by the `billboard_tag` helper

function color(entry) {
  /* TOLO: improve this, this is hacky way of redefine colors js lib uses
    Original colors used:
      color: "gray-300",name: "Used", type: "donut"
      color: "cyan", name: "Unused", type: "donut"
  */
  if(entry.color == "cyan"){
    entry.color= "info"
  }
  return getComputedStyle(document.body).getPropertyValue(`--bs-${entry.color}`)
}

async function initBillboard(element) {
  const { bb, bar, donut, line } = await import('billboard.js')
  const data    = JSON.parse(element.dataset['data'])
  const x       = JSON.parse(element.dataset['x']) || {}
  const y       = JSON.parse(element.dataset['y']) || {}
  const legend  = JSON.parse(element.dataset['legend'])
  const labels  = JSON.parse(element.dataset['labels'])
  const groups  = JSON.parse(element.dataset['groups'] || null)
  const rotated = JSON.parse(element.dataset['rotated'])

  bb.generate({
    bindto: element,
    data:   {
      x: x.values ? 'x' : null,
      types: Object.fromEntries(
        data.map(({name, type}) => {
          switch (type) {
            case 'donut': return [name, donut()]
            case 'bar':   return [name, bar()]
            case 'line':  return [name, line()]
          }
        })
      ),
      columns: [
        ...x.values ? [['x', ...x.values]] : [],
        ...data.map(({name, values}) => [name, ...values])
      ],
      colors: Object.fromEntries(
        data
        .filter((entry) => entry.color)
        .map((entry) => {
          return [entry.name, color(entry)]
        })
      ),
      axes: Object.fromEntries(
        data
        .filter((entry) => entry.y)
        .map((entry) => [entry.name, entry.y])
      ),
      order: data.every((entry) => entry.type === 'donut') ? null : 'desc',
      groups: groups ? [groups] : []
    },
    donut: {
      title: element.getAttribute('title'),
      label: {
        show: labels !== false,
        format: function(value, ratio, id) {
          return `${value}`
        }
      },
      width: 8
    },
    bar: {
      padding: 10
    },
    line: {
      width: 10
    },
    tooltip: {
      format: {
        title: function() { return '' }
      }
    },
    axis: {
      x: {
        type: x.type || 'category',
        show: x.show ?? true
      },
      y: {
        show: y.show ?? true
      },
      y2: {
        show: data.some((entry) => entry.y == 'y2')
      },
      rotated: rotated
    },
    legend: {
      show: legend !== false
    },
    point: {
      r: 3.5
    }
  })
}

async function initBillboards(event) {
  const elements = document.querySelectorAll('billboard')
  if (elements.length == 0) { return }

  elements.forEach((element) => {
    initBillboard(element)
  })
}

document.documentElement.addEventListener('turbo:load', initBillboards)
document.documentElement.addEventListener('turbo:frame-render', initBillboards)
